import Toggle from './Toggle';
import Toggler from './Toggler';
// import './toggle.scss'

Toggle.Toggler = Toggler;

export default Toggle;